<template>
    <div class="char" id="pdfCentent" ref="char" style="min-height: 3000px;">
        <div class="weekly">
            <div class="weekly-header">
                <div class="tit">{{($route.query.weeklyType=='1'?'【'+weeklyInfo.dealDate.substr(0,4)+' 年 '+weeklyInfo.dealDate.substr(5,2)+' 月'+'月报】':'') + weeklyInfo.productName}}</div>
                <ul class="list">
                    <li><span>日期</span>{{weeklyInfo.dealDate}}</li>
                    <li><span>单位净值</span>{{weeklyInfo.unitEquity}}</li>
                    <li><span>累计净值</span>{{weeklyInfo.accumulateEquity}}</li>
                    <li v-if="$route.query.weeklyType=='1'"><span>月度收益</span>{{weeklyInfo.monthlyYield}}</li>
                    <li v-else><span>周度收益</span>{{weeklyInfo.weeklyYield}}</li>
                    <li><span>累计收益</span>{{weeklyInfo.totalYield}}</li>
                </ul>
            </div>
            <!-- 月度净收益率 -->
            <div v-show="$route.query.weeklyType=='1'&&comTable.length>0" ref="ydsy">
                <div class="weekly-subtit" >【 月度净收益率 】</div>
                <el-table class="table-two mt20" :data="comTable" border>
                    <el-table-column prop="name"></el-table-column>
                    <el-table-column prop="0" label="1月"></el-table-column>
                    <el-table-column prop="1" label="2月"></el-table-column>
                    <el-table-column prop="2" label="3月"></el-table-column>
                    <el-table-column prop="3" label="4月"></el-table-column>
                    <el-table-column prop="4" label="5月"></el-table-column>
                    <el-table-column prop="5" label="6月"></el-table-column>
                    <el-table-column prop="6" label="7月"></el-table-column>
                    <el-table-column prop="7" label="8月"></el-table-column>
                    <el-table-column prop="8" label="9月"></el-table-column>
                    <el-table-column prop="9" label="10月"></el-table-column>
                    <el-table-column prop="10" label="11月"></el-table-column>
                    <el-table-column prop="11" label="12月"></el-table-column>
                    <el-table-column prop="12" label="年度"></el-table-column>
                </el-table>
            </div>
            <!-- 净值表现 -->
            <div ref="jzbx">
                <div class="weekly-subtit">【 净值表现 】</div>
                <div class="weekly-chart" style="width:100%;height:357px;"><chart :option="optionJzbx" id="jzbx"></chart></div>
            </div>
            <!-- 产品要素 -->
            <div class="weekly-aside" ref="cpys">
                <div class="weekly-aside-con">
                    <div class="weekly-subtit">【 产品要素 】</div>
                    <table class="weekly-table" cellspacing="0">
                        <tbody>
                            <tr>
                                <td>管理人</td>
                                <td style="font-weight: bold;">{{weeklyArchives.fundManager}}</td>
                            </tr>
                            <tr>
                                <td>投资顾问</td>
                                <td>{{weeklyArchives.fundAdviser}}</td>
                            </tr>
                            <tr>
                                <td>托管人</td>
                                <td>{{weeklyArchives.custodianBank}}</td>
                            </tr>
                            <tr>
                                <td>基金备案号</td>
                                <td>{{weeklyArchives.regNum}}</td>
                            </tr>
                            <tr>
                                <td>成立日期</td>
                                <td>{{weeklyArchives.createDate}}</td>
                            </tr>
                            <tr>
                                <td>费用</td>
                                <td>{{weeklyArchives.sundryCost}}</td>
                            </tr>
                            <tr>
                                <td>封闭期</td>
                                <td>{{weeklyArchives.lockupPeriod}}</td>
                            </tr>
                            <tr>
                                <td>赎回费</td>
                                <td>{{weeklyArchives.redeemCost}}</td>
                            </tr>
                            <tr>
                                <td>预警线</td>
                                <td>{{weeklyArchives.warningLine}}</td>
                            </tr>
                            <tr>
                                <td>认购起点</td>
                                <td>{{weeklyArchives.applyOrigin}}</td>
                            </tr>
                            <tr>
                                <td>认购/赎回<br>开放日</td>
                                <td>{{weeklyArchives.openPerDesc}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="weekly-aside-con">
                    <div class="weekly-subtit">【 当前投资组合仓位 】</div>
                    <div class="weekly-aside-tt t1"><span>策略仓位</span><span>{{parseFloat(positionAll).toFixed(2)}}%</span></div>
                    <ul class="weekly-aside-ul">
                        <li v-for="(item,i) in position" :key="i">
                            <span>{{item.name}}</span>
                            <span>{{parseFloat(item.value*100).toFixed(2)}}%</span>
                        </li>
                    </ul>
                    <div class="weekly-aside-tt t2"><span>流动性仓位（已扣费）</span><span>{{parseFloat(100-positionAll).toFixed(2)}}%</span></div>
                    <div class="all">
                        <span>总仓位</span>
                        <span>100.00%</span>
                    </div>
                    <div class="care">注：流动性仓位为资产管理人为增大投资人收益而进行的现金管理</div>
                    <div class="weekly-subtit">【 持仓状态 】</div>
                    <div class="weekly-chart" style="width:100%;height:308px;"><chart :option="optionCczt" id="cczt"></chart></div>
                </div>
            </div>
            <div class="weekly-subtit">【 历史仓位 】</div>
            <div class="weekly-chart" ref="lscw" style="width:100%;height:450px;"><chart :option="optionLscw" id="lscw"></chart></div>
            <div class="weekly-subtit">【 近一{{$route.query.weeklyType=='1'?'月':'周'}}各策略贡献度 】</div>
            <div class="weekly-chart" ref="clgx" style="width:100%;height:524px;"><chart :option="optionClgx" id="clgx"></chart></div>
            <!-- 月报观点 -->
            <div v-if="$route.query.weeklyType=='1' && monthViews.length > 0">
                <div :id="'ybgd'+i" v-for="(item,i) in monthViews" :key="i+'t'">
                    <div class="weekly-subtit">{{'【 '+ item.title +' 】'}}</div>
                    <div class="weekly-tips" v-for="(val,v) in item.contents" :key="v+'c'">
                        <p v-if="val.contentType == 0">{{ val.content }}</p>
                        <img v-else :src="val.content" alt="">
                    </div>
                </div>
            </div>
            <div class="weekly-subtit">【 风险提示 】</div>
            <div class="weekly-tips" ref="fxts">
                <p>管理人不保证本金不受损失、不保证本基金计划一定盈利，也不保证最低收益。管理人管理的其它基金计划的业绩，并不构成本基金计划业绩表现的保证。基金投资附带风险，请投资者审慎决策，如有疑问欢迎来电咨询。本基金计划的具体内容以募集时和净值公布日管理人正式发布的基金文件为准。 </p>
                <p class="mt5x`">本基金定期报告仅向该基金的基金投资者定向发送，仅供本基金的基金投资者本人参考和使用，收到本报告的基金投资者对报告中的所有内容承担保密义务，未经弘酬投资事先书面同意，不得更改或以任何方式传送、复印或派发本报告内容给予任何其它人。</p>
                <div class="statement">【声明】本基金定期报告仅向该基金的基金投资者定向发送，仅供本基金的基金投资者参考和使用，未经弘酬投资事先书面同意，不得更改或以任何方式传送、复印或派发本报告内容给予任何其它人。</div>
            </div>
        </div>
        <div class="upload" v-if="loading"  @click="download"><i class="el-icon-bottom"></i></div>
    </div>
</template>

<script>
    import chart from "../../components/chart";
    import html2canvas from 'html2canvas';
    export default {
        components:{
            chart
        },
        data() {
            return {
                optionJzbx: {
                    title:{},
                    color:['#4f81bd'],
                    grid: {top:'15%',left: '4%',right: '4%',bottom: '10%',containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:14,color: "#333",rotate:50,},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: false,
                    },
                    yAxis:{
                        type:'value',
                        min: function(value) {
                            return parseFloat(value.min - 0.05).toFixed(2)
                        },
                        axisLabel: {
                            formatter:function (val){return (val).toFixed(4)},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter:function (params) {
                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td class="'+(params[i].value>0?'rColor':'gColor')+'">'+(params[i].value).toFixed(4)+'</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[
                        {
                            name:'净值表现',
                            type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                            data:[]
                        }
                    ],
                },
                optionCczt: {
                    title:{},
                    color:['#4F81BD','#C0504D','#9BBB59','#8064A2','#4BACC6','#F79646'],
                    tooltip: {trigger: 'item',formatter: "{b}：{d}% "},
                    calculable: true,
                    series: [{
                        name: '',
                        type: 'pie',
                        radius: '75%', //饼图的半径大小
                        center: ['50%', '50%'], //饼图的位置
                        label: { //饼图图形上的文本标签
                            normal: {
                                show: true,
                                textStyle:{fontSize: 16,fontWeight:500},
                                formatter: '{b} {d}%'
                            }
                        },
                        itemStyle:{borderColor:'#fff',borderWidth:2},
                        data:[]
                    }]
                },
                optionLscw:{
                    title:{},
                    color:['#4F81BD','#C0504D','#9BBB59','#8064A2','#4BACC6','#F79646'],
                    legend:{
                        icon:'rect',itemWidth: 10,itemHeight: 10,bottom:20,itemGap:40,formatter:'{name}',textStyle:{fontSize:16,color:'#333',},pageIconColor: "#01567F",
                    },
                    grid: {top:'10%',left: '3%',right: '3%',bottom: '15%',containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:14,color: "#333",rotate:90},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: false,
                    },
                    yAxis:{
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return (val*100).toFixed(2)+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter:function (params) {
                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td class="'+(params[i].value>=0?'rColor':'gColor')+'">'+(params[i].value*100).toFixed(2)+'</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[]
                },
                optionClgx:{
                    title:{},
                    color:['#236EAC','#FF7723','#0263FF','#8E30FF'],
                    grid: {top:'60',left: '3%',right: '3%',bottom: '50',containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:14,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: true,
                    },
                    yAxis:{
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return parseFloat(val*100).toFixed(3)+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: "shadow",
                            shadowStyle: {color: "rgba(0, 0, 0, 0.08)"}
                        },
                        formatter:function (params) {
                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td>'+(parseFloat(params[i].value*100).toFixed(3)+'%')+'</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[]
                },
                loading: false,
                ProductCode: '',
                weeklyInfo: {
                    productName: '--',
                    dealDate: '--',
                    unitEquity: '--',
                    accumulateEquity: '--',
                    weeklyYield: '--',
                    totalYield: '--',
                },
                weeklyArchives: {
                    fundManager: '--',    //管理人
                    fundAdviser: '--',    //投资顾问
                    custodianBank: '--',  //托管人
                    regNum: '--',         //备案编号
                    createDate: '--',     //成立日期
                    sundryCost: '--',     //费用
                    lockupPeriod: '--',   //封闭期
                    redeemCost: '--',     //赎回费
                    warningLine: '--',    //预警线
                    applyOrigin: '--',    //认购起点
                    openPerDesc: '--',    //开放日
                },
                position: [],
                positionAll: 0,
                // 月度
                comTable: [],
                dealDate: '',
                monthViews: [],
                elementTop :[]
            }
        },
        mounted() {
            this.ProductCode = this.$route.query.weeklyCode
            this.dealDate = this.$route.query.dealDate
            if(this.$route.query.weeklyType=='1') {
                document.title = '月报_金方数据库'
            }
            this.getWeekly()
            this.getViewList()
            this.getMonthlyYield()
            this.$nextTick(() => {
                this.loading = true
            })
        },
        methods: {
            getWeekly() {
                // 获取周报基本信息
                this.$http.post(this.$apiPath.GetWeeklyInfo,{
                    ProductCode: this.ProductCode,
                    DealDate: this.dealDate,
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        this.weeklyInfo = res.data.data
                        this.getWeeklyPosition()
                        this.getWeeklyYieldPosition()
                    }
                }).catch(err=>{})

                // 获取周报走势图
                this.$http.post(this.$apiPath.GetWeeklyTrendCharts,{
                    ProductCode: this.ProductCode
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        this.optionJzbx.xAxis.data = res.data.data.dateList
                        let seriesData=[];
                        res.data.data.nameList.forEach((val,ind)=>{
                            seriesData.push({
                                name:val,
                                type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                lineStyle: {width: 4},
                                data:res.data.data.dataList[ind]
                            })
                        })
                        this.optionJzbx.series=seriesData;
                    }
                }).catch(err=>{})

                // 获取周报产品要素
                this.$http.post(this.$apiPath.GetWeeklyArchives,{
                    ProductCode: this.ProductCode
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        this.weeklyArchives = res.data.data
                    }
                }).catch(err=>{})

                // 获取周报策略历史仓位
                this.$http.post(this.$apiPath.GetWeeklyPositionList,{
                    ProductCode: this.ProductCode
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        // this.weeklyArchives = res.data.data
                        this.optionLscw.xAxis.data = res.data.data.dateList
                        let seriesData=[];
                        res.data.data.nameList.forEach((val,ind)=>{
                            seriesData.push({
                                name: val,
                                type: 'line',
                                symbol:'circle',showSymbol: false,symbolSize:8,areaStyle:{opacity:1},stack: 'Total',
                                data: res.data.data.dataList[ind],
                            })
                        })
                        this.optionLscw.series=seriesData;
                    }
                }).catch(err=>{})
            },
            // 组合仓位
            getWeeklyPosition() {
                this.$http.post(this.$apiPath.GetWeeklyPosition,{
                    ProductCode: this.ProductCode,
                    DealDate: this.weeklyInfo.dealDate,
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        this.position = res.data.data.dataList
                        let seriesData=[];
                        if(this.position && this.position.length > 0) {
                            for(let i=0;i<this.position.length;i++){
                                this.positionAll+=this.position[i].value*100;
                                seriesData.push({
                                    name:this.position[i].name,
                                    value:this.position[i].value*100,
                                    label:{
                                        normal:{
                                            position:'outside',
                                            textStyle:{color:'inherit'}
                                        }}
                                    },
                                )
                            }
                        }
                        seriesData.push(
                            {
                                name:'流动性仓位',
                                value:parseFloat((100-this.positionAll)).toFixed(2),
                                label:{
                                    normal:{
                                        position:'outside',
                                        textStyle:{color:'inherit'}
                                    }
                                }
                                        
                            }
                        )
                        this.optionCczt.series[0].data = seriesData
                    }
                }).catch(err=>{})
            },
            // 策略贡献
            getWeeklyYieldPosition() {
                this.$http.post(this.$apiPath.GetWeeklyYieldPosition,{
                    ProductCode: this.ProductCode,
                    DealDate: this.weeklyInfo.dealDate,
                    DateType: this.$route.query.weeklyType=='1' ? 1 : 0
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        let seriesData=[];
                        res.data.data.nameList.forEach((item,ind) => {
                            seriesData.push({
                                name: item,
                                type: 'bar',
                                barWidth:50,
                                label: {
                                    show: true,
                                    position: 'top',
                                    fontSize: '14px',
                                    formatter:function (val){return parseFloat(val.value*100).toFixed(3)+'%'},
                                },
                                data: res.data.data.dataList[ind],
                            })
                        })
                        this.optionClgx.xAxis.data = res.data.data.dateList
                        this.optionClgx.series = seriesData
                    }
                }).catch(err=>{})
            },
            download() {
                this.getElementTop()
                this.ExportSavePdf(this.weeklyInfo.productName+(this.$route.query.weeklyType=='1'?'月报':'周报'), this.elementTop,'')
            },
            //图片转换格式
            dataURLToBlob(dataurl) {
                let arr = dataurl.split(',');
                let mime = arr[0].match(/:(.*?);/)[1];
                let bstr = atob(arr[1]);
                let n = bstr.length;
                let u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },
            //保存图片的方法，id名 图片名称
            saveImage(divText, imgText) {
                let canvasID = this.$refs[divText];
                let that = this;
                let a = document.createElement('a');
                html2canvas(canvasID).then(canvas => {
                    let dom = document.body.appendChild(canvas);
                    dom.style.display = 'none';
                    a.style.display = 'none';
                    document.body.removeChild(dom);
                    let blob = that.dataURLToBlob(dom.toDataURL('image/png'));
                    a.setAttribute('href', URL.createObjectURL(blob));
                    //这块是保存图片操作  可以设置保存的图片的信息
                    a.setAttribute('download', imgText + '.png');
                    document.body.appendChild(a);
                    a.click();
                    URL.revokeObjectURL(blob);
                    document.body.removeChild(a);
                });
                // this.loading = false
            },
            // 月报观点
            getViewList() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetViewList,{
                    ProductCode: vm.ProductCode,
                    UserCode: vm.$commonJs.getCookie('userCode'), //用户编号
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        vm.monthViews = res.data.data.dataList
                    }
                    
                }).catch(err => {})
            },
            // 获取月报月度净收益率
            getMonthlyYield() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetMonthlyYield,{
                    ProductCode: vm.ProductCode,
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        let newYear = new Date().getFullYear()
                        let years = []
                        for(let i = 0; i < 5; i++) {
                            years.push(newYear-i)
                        }
                        res.data.data.dataList.forEach((item,i) => {
                                item.name = years.reverse()[i]
                        })
                        vm.comTable = res.data.data.dataList
                    }
                }).catch(err=>{})
            },
            getElementTop(){
                let vm = this
                vm.elementTop.push(this.$refs.ydsy.offsetTop + this.$refs.ydsy.offsetHeight + 5)
                vm.elementTop.push(this.$refs.jzbx.offsetTop + this.$refs.jzbx.offsetHeight + 5)
                vm.elementTop.push(this.$refs.cpys.offsetTop + this.$refs.cpys.offsetHeight + 5)
                vm.elementTop.push(this.$refs.lscw.offsetTop + this.$refs.lscw.offsetHeight + 5)
                vm.elementTop.push(this.$refs.clgx.offsetTop + this.$refs.clgx.offsetHeight + 5)
                if(vm.$route.query.weeklyType=='1') {
                    for(let i = 0; i< this.monthViews.length; i++) {
                        vm.elementTop.push(document.getElementById('ybgd'+String(i)).offsetTop + document.getElementById('ybgd'+String(i)).offsetHeight + 5)
                    }
                }
                vm.elementTop.push(this.$refs.fxts.offsetTop + this.$refs.fxts.offsetHeight + 5)
                // console.log(vm.elementTop);
            }
        }
    }
</script>

<style lang="less" scoped>
.weekly {
    width: 1200px;margin: 0 auto;
    &-header {
        .tit {height: 84px;font-size: 34px;line-height: 84px;color: @whiteColor;background: @mainColorZb;text-align: center;}
        .el-icon-bottom {color: @whiteColor;float: right;cursor: pointer;}
        .list {
            padding: 0 20px;height: 80px;display: flex;justify-content: space-between;align-items: center;border-bottom: 2px solid @mainColorZb;
            li {
                font-size: 20px;color: @color3;
                span {margin-right: 15px;color: @mainColorZb;}
            }
        }
    }
    &-subtit {margin: 38px 0 24px -15px;font-size: 28px;font-weight: bold;color: @mainColorZb;}
    &-chart {border: 1px solid @colorE5;}
    &-aside {
        display: flex;justify-content: space-between;
        &-con {width: 48%;font-size:20px;color:@color3;}
        .all {padding: 20px 41px 25px 20px;display: flex;justify-content: space-between;font-weight: bold;color: @mainColorZb;}
        .care {font-size: 16px;color: @color6;text-align: right;}
        &-tt {height: 58px; display: flex;justify-content: space-between;align-items: center;padding: 0 40px 0 20px;color:@mainColorZb;font-weight: bold;background: @oColor3;}
        .t1 {border-top: 1px solid @mainColorZb;}
        .t2 {border-bottom: 1px solid @mainColorZb;}
        &-ul {
            padding: 10px 41px;box-sizing: border-box;
            li {height: 50px; display: flex;justify-content: space-between;align-items: center;}
        }
    }
    &-table {
        width: 100%;border: 1px solid @colorE5;
        tr:nth-child(2n+1) {background: @oColor3;}
        tr td{padding: 20px;}
        tr td:first-child {min-width: 130px;color:@mainColorZb;font-weight: bold;}
    }
    &-tips {
        font-size: 20px;color: @color3;line-height: 35px;text-align: center;
        p {text-indent: 2em;text-align: justify;}
        img {height: 260px;padding: 20px 0;}
        .statement {color: @color9;padding: 97px 0 48px;}
    }
}
.char{
    position: relative;width: 1320px;margin: 0 auto;
    .upload {
        position: fixed;
        background-color: transparent;
        width: 40px;
        height: 40px;
        right: 50px;
        top: 100px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        box-shadow: 0 0 9px #91b6d6;
        cursor: pointer;
        z-index: 5;
        color: @mainColorZb;
    }
}
</style>